import { defaultNS, useTranslation } from "@/lib/i18n";

export function useDeviceActivityType() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "domain.device.activityType",
  });

  return {
    i18n: t,
  };
}
